export default __webpack_public_path__ + "static/media/icon-outbound-call.a0a0eecb.svg";